export const InteractiveQASessionsData = [
    {
        title: 'In Conversation with Alice Evans (moderated by Aditi Bhowmick)',
        desc: 'Dr.Alice Evans talks about her fascinating research on gender (in)equality in South Asia, and tells an inspiring personal story of grit and resilience.',
        url: 'https://www.youtube.com/watch?v=CDQlM0FxV5Y&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
    {
        title: 'In Conversation with Dr. Rohini Panade',
        desc: 'Dr Rohini Pande is currently the Henry J. Heinz II Professor of Economics and Director of the Economic Growth Center, Yale University.',
        url: 'https://www.youtube.com/watch?v=jOZcypPHIkI'

    },
    {
        title: 'In conversation with Sharayana Bhattacharya',
        desc: 'We speak to economist Shrayana Bhattacharya about her pathbreaking book Desperately Seeking Shah Rukh, her career and journey in the field of development and policy.',
        url: 'https://www.youtube.com/watch?v=KfyHjS5ehT8&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
    {
        title: 'In Conversation with Alice Evans (moderated by Aditi Bhowmick)',
        desc: 'Dr.Alice Evans talks about her fascinating research on gender (in)equality in South Asia, and tells an inspiring personal story of grit and resilience.',
        url: 'https://www.youtube.com/watch?v=CDQlM0FxV5Y&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
    {
        title: 'In Conversation with Dr. Rohini Panade',
        desc: 'Dr Rohini Pande is currently the Henry J. Heinz II Professor of Economics and Director of the Economic Growth Center, Yale University.',
        url: 'https://www.youtube.com/watch?v=jOZcypPHIkI'

    },
    {
        title: 'In conversation with Sharayana Bhattacharya',
        desc: 'We speak to economist Shrayana Bhattacharya about her pathbreaking book Desperately Seeking Shah Rukh, her career and journey in the field of development and policy.',
        url: 'https://www.youtube.com/watch?v=KfyHjS5ehT8&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
    {
        title: 'In conversation with Sharayana Bhattacharya',
        desc: 'We speak to economist Shrayana Bhattacharya about her pathbreaking book Desperately Seeking Shah Rukh, her career and journey in the field of development and policy.',
        url: 'https://www.youtube.com/watch?v=KfyHjS5ehT8&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    }
]

export const ResearchPresentationsData = [
    {
        title: 'Member Research Presentation with Aditi Bhowmick',
        desc: 'Aditi Bhowmick is currently a pre-doc at Development Data Lab. She has a Masters in Public Administration (Economics & Public Policy) from the School of Public and International Affairs at Princeton University',
        url: 'https://www.youtube.com/watch?v=pC2jUohHy1w&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net',
    },
    {
        title: 'Research Presentation with Dr Anisha Sharma',
        desc: 'Dr. Anisha Sharma is an Assistant Professor of Economics at Ashoka University. Her main research interests are development and labour economics.',
        url: 'https://www.youtube.com/watch?v=pn4X0NumsQM&t=26s'
    },
    {
        title: 'Research Presentation with Dr Kanika Mahajan',
        desc: 'Dr Kanika Mahajan is an Assistant Professor of Economics at Ashoka University. ',
        url: 'https://www.youtube.com/watch?v=oOCcuRNUloM&t=23s'
    },
    {
        title: 'Research Presentation with Madeline McKelway',
        desc: 'Madeline McKelway is a PhD candidate in Economics at the University of California, Berkeley. Her research focuses on the economics of education and labor market outcomes.',
        url: 'https://www.youtube.com/watch?time_continue=17&v=biuGNIci3Cw&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
]

export const WorkshopInformationSessionsData = [
    {
        title: 'Information Session on Applying for a Masters in Economics Program in India',
        desc: 'The final session of the Application Support Month talked about the applying for a Masters in Economics Program in India. Watch Poonam Kumari, alumni of ISI Delhi share her experiences and weigh on the different aspects of the application and entrance process.',
        url: 'https://www.youtube.com/watch?v=Zuq-82OcE-Q'
    },
    {
        title: 'Applying to PhD Programs in Economics and Public Policy',
        desc: 'Prachi Shukla, Vasanthi S Pillai and Anahita Karandikar talk about applying to PhD programs in economics and public policy in North America and Europe. They share details regarding the application process, material required to apply and how to get through application season.',
        url: 'https://www.youtube.com/watch?v=shxzwdJv5bY&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
    {
        title: 'Information Session on Applying to Graduate Programs in Public Policy',
        desc: 'Women in Econ/Policy kickstarted their Application Support Month with a session on Applying to Graduate Programs in Public Policy with incoming public policy candidates, Smriti Saini and Samia Mehraj',
        url: 'https://www.youtube.com/watch?v=MRVJ1IpJEVo'
    },
    {
        title: 'Information Session on Applying for a Masters in Economics Program in India',
        desc: 'The final session of the Application Support Month talked about the applying for a Masters in Economics Program in India. Watch Poonam Kumari, alumni of ISI Delhi share her experiences and weigh on the different aspects of the application and entrance process.',
        url: 'https://www.youtube.com/watch?v=Zuq-82OcE-Q'
    },
    {
        title: 'Applying to PhD Programs in Economics and Public Policy',
        desc: 'Prachi Shukla, Vasanthi S Pillai and Anahita Karandikar talk about applying to PhD programs in economics and public policy in North America and Europe. They share details regarding the application process, material required to apply and how to get through application season.',
        url: 'https://www.youtube.com/watch?v=shxzwdJv5bY&embeds_referring_euri=https%3A%2F%2Feditor.wixapps.net%2F&embeds_referring_origin=https%3A%2F%2Feditor.wixapps.net'
    },
    {
        title: 'Information Session on Applying to Graduate Programs in Public Policy',
        desc: 'Women in Econ/Policy kickstarted their Application Support Month with a session on Applying to Graduate Programs in Public Policy with incoming public policy candidates, Smriti Saini and Samia Mehraj',
        url: 'https://www.youtube.com/watch?v=MRVJ1IpJEVo'
    },
    {
        title: 'Information Session on Applying to Graduate Programs in Public Policy',
        desc: 'Women in Econ/Policy kickstarted their Application Support Month with a session on Applying to Graduate Programs in Public Policy with incoming public policy candidates, Smriti Saini and Samia Mehraj',
        url: 'https://www.youtube.com/watch?v=MRVJ1IpJEVo'
    }

]